export const siteTitle = {
	home: "Holipic Al Powered Instant Photography",
	shop: "Holipic Booking-shop",
	booking_details: "Holipic Booking-details",
	booking_schedule: "Holipic Booking-schedule",
	booking_lists: "Holipic Booking-lists",
	// super_admin: "Holipic Booking-lists",
};
